import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiParcelsMyGet } from '@/entities/parcels/modules/api/parcels';

export const useMyParcels = (cargoId?: string) =>
  useFetch({
    api: () => apiParcelsMyGet(cargoId || undefined),
    keywords: queryKeys.parcels.my(cargoId ? { cargo_id: cargoId } : undefined),
    staleTime: 60_000,
  });
